// extracted by mini-css-extract-plugin
module.exports = {"marqueeContainer":"social-proof_marqueeContainer__PT9PM","bodyContainer":"social-proof_bodyContainer__AECOz","marqueeFade":"social-proof_marqueeFade__dYW5j"};